import { useState } from "react";
import { Container, Row, Col, Button, Spinner } from "react-bootstrap";
import "../../../assets/css/customer/screens/home/EstaticeLaser.css";
import { useNavigate } from "react-router-dom";
const laserServices = [
  {
    id: 1,
    name: "Laser Hair Removal",
    desc: "Smooth, hair-free skin.",
  },
  {
    id: 2,
    name: "Laser Skin Resurfacing",
    desc: "Smoother texture, refined pores.",
  },
  {
    id: 3,
    name: "Laser Acne Treatment",
    desc: "Clear acne and reduce scars.",
  },
];

const EstaticeLaser = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleExplore = () => {
    setLoading(true);
    navigate("/treatments");
  };
  return (
    <section className="ac-laser">
      <Container className="ac-laser__container">

        {/* Header */}
        <div className="ac-laser__header">
          <span className="ac-laser__label">ADVANCED TECHNOLOGY</span>
          <h2 className="ac-laser__heading">Laser treatments</h2>
          <p className="ac-laser__subtext">
            FDA-cleared diode and fractional laser systems delivered by certified
            clinicians.
          </p>
        </div>

        {/* Cards Row */}
        <Row className="ac-laser__row justify-content-center">
          {laserServices.map((service) => (
            <Col lg={4} md={4} sm={12} key={service.id} className="ac-laser__col">
              <div className="ac-laser__card">
                <div className="ac-laser__icon-wrap">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#e27a8b"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
                  </svg>
                </div>
                <h5 className="ac-laser__card-name">{service.name}</h5>
                <p className="ac-laser__card-desc">{service.desc}</p>
              </div>
            </Col>
          ))}
        </Row>

        {/* Explore Button */}
        <div className="ac-laser__btn-wrap">
          <Button className="ac-laser__btn"
            onClick={handleExplore}
            disabled={loading}
            >
            {loading ? (
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
            ) : (
              "Explore lasers"
            )}
          </Button>
        </div>

      </Container>
    </section>
  );
};

export default EstaticeLaser;